import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const BaseStyle: StyleRule = () => ({
    flexFlow: 'wrap',
    rowGap: pxToRem(8),
});
